module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('FirstName')
    },
    attrs: {
      "type": "text",
      "name": "FirstName",
      "id": "FirstName",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('FirstName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('LastName')
    },
    attrs: {
      "type": "text",
      "name": "LastName",
      "id": "LastName",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('LastName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "date-time-input"
    }
  }, [_vm._v("Date of birth "), (!_vm.looseValidation) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-group date birth-field-bottom"
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.looseValidation
      }),
      expression: "{required: !looseValidation}"
    }],
    class: {
      'form-control': true, 'form-control-error': !_vm.looseValidation && _vm.isBirthFieldInvalid
    },
    attrs: {
      "placeholder": "mm/dd/yyyy",
      "id": "date-time-input",
      "name": "date-time-input",
      "wrap": true,
      "config": _vm.dateBirthConfig
    },
    nativeOn: {
      "blur": function($event) {
        _vm.checkDateBirth(_vm.dateOfBirth)
      }
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), (!_vm.looseValidation && _vm.isBirthFieldInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e(), _vm._v(" "), (!_vm.looseValidation && !this.isDateBirthValid(_vm.dateOfBirth)) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("You must be 18 years or older in order to invest with us.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ssn"
    }
  }, [_vm._v("Social security number "), (!_vm.looseValidation) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "availability-check-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialSecurityNum),
      expression: "socialSecurityNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.looseValidation,
        regex: /(^[0-9]{3}\-[0-9]{2}\-[0-9]{4}$)|(x{3}\-x{2}(\-[0-9]{4})?)/
      }),
      expression: "{required: !looseValidation, regex: /(^[0-9]{3}\\-[0-9]{2}\\-[0-9]{4}$)|(x{3}\\-x{2}(\\-[0-9]{4})?)/}"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('***-**-9999'),
      expression: "'***-**-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('ssn')
    },
    attrs: {
      "type": "text",
      "name": "ssn",
      "id": "ssn",
      "placeholder": "000-00-0000",
      "onfocus": "this.value=''"
    },
    domProps: {
      "value": (_vm.socialSecurityNum)
    },
    on: {
      "click": function($event) {
        _vm.socialSecurityNum = ''
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.socialSecurityNum = $event.target.value
      }, _vm.ssnInput],
      "blur": _vm.checkSsnAvailability
    }
  }), _vm._v(" "), (_vm.ssnAvailabilityStatus !== null) ? _c('div', {
    staticClass: "availability-indicator"
  }, [(_vm.ssnAvailabilityStatus === 'checking') ? _c('span', {
    staticClass: "fa fa-spinner fa-spin text-info"
  }) : _vm._e(), _vm._v(" "), (_vm.ssnAvailabilityStatus === 'available') ? _c('span', {
    staticClass: "fa fa-check text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.ssnAvailabilityStatus === 'unavailable') ? _c('span', {
    staticClass: "fa fa-times text-danger"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.errors.has('ssn')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('ssn')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Primary email"), (_vm.emailRequired) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "availability-check-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('PrimaryEmail')
    },
    attrs: {
      "type": "text",
      "name": "PrimaryEmail",
      "id": "PrimaryEmail",
      "placeholder": "Primary email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.emailUpdated],
      "blur": _vm.checkEmailAvailability
    }
  }), _vm._v(" "), (_vm.emailAvailabilityStatus !== null) ? _c('div', {
    staticClass: "availability-indicator"
  }, [(_vm.emailAvailabilityStatus === 'checking') ? _c('span', {
    staticClass: "fa fa-spinner fa-spin text-info"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'available') ? _c('span', {
    staticClass: "fa fa-check text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'unavailable') ? _c('span', {
    staticClass: "fa fa-times text-danger"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.errors.has('PrimaryEmail')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('PrimaryEmail')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Secondary email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondaryEmail),
      expression: "secondaryEmail"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('SecondaryEmail')
    },
    attrs: {
      "type": "text",
      "name": "SecondaryEmail",
      "id": "SecondaryEmail",
      "placeholder": "Secondary Email"
    },
    domProps: {
      "value": (_vm.secondaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secondaryEmail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('SecondaryEmail')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('SecondaryEmail')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryPhoneNum),
      expression: "primaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /(^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$)|([0-9]{10})/
      }),
      expression: "{ required: true, regex: /(^\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}$)|([0-9]{10})/ }"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('primaryPhoneNum')
    },
    attrs: {
      "id": "primaryPhoneNum",
      "name": "primaryPhoneNum",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.primaryPhoneNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.primaryPhoneNum = $event.target.value
      }, _vm.onPhoneNumberChange]
    }
  }), _vm._v(" "), (_vm.errors.has('primaryPhoneNum')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "secondaryPhoneNum"
    }
  }, [_vm._v("Secondary phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondaryPhoneNum),
      expression: "secondaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /(^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$)|([0-9]{10})/
      }),
      expression: "{ regex:/(^\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}$)|([0-9]{10})/ }"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('secondaryPhoneNum')
    },
    attrs: {
      "id": "secondaryPhoneNum",
      "name": "secondaryPhoneNum",
      "type": "text"
    },
    domProps: {
      "value": (_vm.secondaryPhoneNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.secondaryPhoneNum = $event.target.value
      }, _vm.onPhoneNumberChange]
    }
  }), _vm._v(" "), (_vm.errors.has('secondaryPhoneNum')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Wrong phone number")]) : _vm._e()])])]), _vm._v(" "), (_vm.enableMfa) ? _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mfaPhonePreference),
      expression: "mfaPhonePreference"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mfaPhonePreference"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mfaPhonePreference = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-- Select --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PRIMARY",
      "disabled": !_vm.hasPrimaryPhone
    }
  }, [_vm._v("\n            Primary Phone\n          ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SECONDARY",
      "disabled": !_vm.hasSecondaryPhone
    }
  }, [_vm._v("\n            Secondary Phone\n          ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NONE"
    }
  }, [_vm._v("None (Email only)")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n          Select which phone number should be used for SMS multi-factor authentication.\n        ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("First name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Last name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "primaryPhoneNum"
    }
  }, [_vm._v("Primary phone number "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "mfaPhonePreference"
    }
  }, [_c('strong', [_vm._v("MFA Phone Preference")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51ce0a00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasicInformation.vue
// module id = 2148
// module chunks = 1